import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;

const styles: Record<string, SxProps> = {
  // layout styles
  mainBox: {
    overflow: {
      xs: 'hidden'
      // lg: 'initial'
    },
    position: 'relative',
    marginTop: '5.625rem',
    paddingY: spacing(4),

    '.bg-default': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0
    },

    '& .anchorLinks': {
      color: palette.grey['50']
    },

    '.hero-btn': {
      textDecoration: 'none',
      width: { xs: '100%', md: 'auto' }
    }
  },

  layoutContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    position: 'relative',
    height: '100%',
    justifyContent: 'center',
    paddingLeft: {
      sm: spacing(4)
    },
    wordBreak: 'break-word',
    background: 'none'
  },

  internalLayout: {
    maxWidth: {
      xs: '100%',
      sm: '80vw'
    },
    width: { xs: '100%', sm: 'fit-content' },
    padding: spacing(2),
    background: {
      xs: 'rgba(0, 0, 0, 0.75)',
      sm: 'rgba(0, 0, 0, 0.75)'
    }
  },

  // Text styles
  titleText: {
    color: palette.grey['50'],
    width: '100%',
    marginBottom: spacing(2)
  },

  subheadingText: {
    color: palette.grey['50']
  },

  subtitleText: {
    color: palette.grey['50'],
    marginBottom: spacing(0.5)
  },

  paragraphText: {
    color: palette.grey['50'],
    marginBottom: spacing(0.5)
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: spacing(1),
    marginTop: spacing(2),
    width: {
      xs: '100%',
      sm: 'auto'
    },
    flexDirection: {
      xs: 'column',
      md: 'row'
    }
  },
  heroBtn: {
    textTransform: 'none',
    minWidth: '8rem',
    width: {
      xs: '100%',
      md: 'auto'
    }
  },
  btnLink: {
    textDecoration: 'none',
    width: {
      xs: '100%',
      md: 'auto'
    }
  },

  // BackgroundImg styles
  bgImgNormalVar: {
    position: 'absolute',
    top: '0',
    display: 'block',
    width: '100%',
    height: '100%',
    left: '0',
    '& img': {
      width: { xs: 'auto', md: '100%' },
      height: '100%',
      objectFit: 'cover',
      transform: { xs: 'translateX(-18%)', md: 'none' }
    }
    // NOTE: if need to control image translation, use width='auto along with transform
  }
};

export default styles;
